/* FISS Bundle Studio – storefront block (v2, 2026-10-22)
 * Reads offers from <script id="fiss-bundle-config">:
 *   draft theme → shop metafield fiss_bundles.config (test: true, nothing is discounted yet)
 *   live theme  → shop metafield fiss_bundles.live   (live: true, the Shopify discounts exist)
 * Renders every offer that matches the current product. Customer-facing text is Traditional Chinese.
 * Set prices (fixed set, build your own, set-price add-ons / combos) get a one-use code from FISS at the button
 * (POST https://www.thefiss.com/_functions/bundlecode), then go to /discount/CODE?redirect=/cart.
 */
(function () {
  var root = document.getElementById('fiss-bundle');
  var cfgEl = document.getElementById('fiss-bundle-config');
  if (!root || !cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.offers) return;
  var P; try { P = JSON.parse(document.getElementById('fiss-bundle-product').textContent); } catch (e) { return; }
  var LIVE = !!cfg.live && !cfg.test;
  var API = cfg.api || 'https://www.thefiss.com/_functions/bundlecode';
  var D = Object.assign({ accent: '#1f3864', btn: '#c9520e', radius: 10, btnText: '加入購物車 · 一次帶走', badge: '省', showSave: true, cdStyle: 'boxes' }, (function (d) { var o = {}; Object.keys(d || {}).forEach(function (k) { if (d[k] !== '' && d[k] != null) o[k] = d[k]; }); return o; })(cfg.design));   // empty settings keep the defaults
  root.style.setProperty('--fb-accent', D.accent); root.style.setProperty('--fb-btn', D.btn); root.style.setProperty('--fb-radius', (+D.radius || 10) + 'px');

  var nt = function (cents) { return 'NT$' + Math.round(cents / 100).toLocaleString('en-US'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var today = new Date(Date.now() + 8 * 3600e3).toISOString().slice(0, 10);   // Taipei date
  var isCode = function (o) { return o.type === 'fixed' || o.type === 'byo' || ((o.type === 'fbt' || o.type === 'addon' || o.type === 'combo') && o.disc && o.disc.kind === 'price'); };
  var zhe = function (pct) { var r = Math.round((100 - pct) * 10) / 10; return (r % 10 === 0 ? r / 10 : r) + ' 折'; };   // Taiwan way: 5% off → 95 折, 10% off → 9 折, 15% off → 85 折

  // variants left out of an offer in Bundle Studio (vars[handle].off = variant ids)
  function offIds(o, h) { var x = o.vars && o.vars[h]; return ((x && x.off) || []).map(String); }
  function okVariants(o, p) { var off = offIds(o, p.handle); return p.variants.filter(function (v) { return off.indexOf(String(v.id)) < 0; }); }
  function firstAvail(p, o) { var vs = o ? okVariants(o, p) : p.variants; return vs.filter(function (v) { return v.available; })[0] || vs[0] || p.variants[0]; }
  // the variant chosen in the product form, when it is part of the offer
  function curVariant(o) {
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]'), id = f && String(f.value), vs = o ? okVariants(o, P.full) : P.full.variants;
    return vs.filter(function (v) { return String(v.id) === id; })[0] || firstAvail(P.full, o);
  }

  function matches(o) {
    if (o.start && o.start > today) { if (LIVE) return false; o._soon = true; }   // draft: upcoming offers show as a preview
    if (o.end && o.end < today) return false;
    var s = o.show || {};
    var hit = s.all || (s.products || []).indexOf(P.handle) > -1 || (s.vendors || []).indexOf(P.vendor) > -1 ||
      (s.collections || []).some(function (c) { return (P.collections || []).indexOf(c) > -1; });
    if (!hit) return false;
    if (o.type === 'gift' && o.gift === P.handle) return false;   // not on the gift's own page
    if (o.vars && offIds(o, P.handle).length && !okVariants(o, P.full).length) return false;   // every variant of this product is left out
    return true;
  }
  var offers = cfg.offers.filter(matches);
  if (!offers.length) return;

  var reduce = false;   // motion stays on for everyone, as set in Bundle Studio (Dang, 2026-10-22: computers with "reduce motion" saw no animation)
  function countUp(el) {
    var to = +el.getAttribute('data-to'); if (reduce) { el.textContent = to.toLocaleString('en-US'); return; }
    el.textContent = '0'; var t0 = performance.now(), dur = 1100;
    (function step(t) { var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(to * e).toLocaleString('en-US'); if (k < 1) requestAnimationFrame(step); else { var sv = el.closest('.fb-sv'); if (sv) sv.classList.add('fb-pop'); } })(t0);
  }

  var cache = {};
  function product(handle) {
    if (handle === P.handle) return Promise.resolve(P.full);
    if (!cache[handle]) cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw new Error(handle); return r.json(); });
    return cache[handle];
  }
  function many(hs) { return Promise.all((hs || []).filter(Boolean).map(function (h) { return product(h).catch(function () { return null; }); })).then(function (ps) { return ps.filter(Boolean); }); }
  var cartP = null;
  function cart() { if (!cartP) cartP = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return { total_price: 0, items: [] }; }); return cartP; }
  function img(p) { var u = p.featured_image || (p.images && p.images[0]) || ''; if (u && u.indexOf('//') === 0) u = 'https:' + u; return u ? (u.indexOf('?') > -1 ? u + '&width=120' : u + '?width=120') : ''; }
  function pic(p) { return img(p) ? '<img src="' + esc(img(p)) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="fb-ph"></span>'; }

  // countdown
  function cdTarget(o) {
    var now = Date.now();
    if (o.cd.mode === 'daily') { var d = new Date(now + 8 * 3600e3); d.setUTCHours(24, 0, 0, 0); return d.getTime() - 8 * 3600e3; }
    return new Date(o.end + 'T23:59:59+08:00').getTime();
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function cdHTML(o) {
    var ms = Math.max(0, cdTarget(o) - Date.now()), s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    var urg = ms < 86400e3 ? ' fb-cd--urgent' : '', lab = o.cd.label || '優惠倒數';
    var dg = function (v, k) { return '<i class="fb-dg" data-k="' + k + '">' + pad(v) + '</i>'; };
    if (D.cdStyle === 'inline') return '<div class="fb-cd fb-cd--inline' + urg + '">⏱ ' + esc(lab) + ' <b>' + dg(d, 'd') + '天 ' + dg(h, 'h') + ':' + dg(m, 'm') + ':' + dg(x, 's') + '</b></div>';
    if (D.cdStyle === 'bar') return '<div class="fb-cd fb-cd--bar' + urg + '"><b>' + esc(lab) + '</b><span>' + dg(d, 'd') + '天 ' + dg(h, 'h') + ':' + dg(m, 'm') + ':' + dg(x, 's') + '</span></div>';
    return '<div class="fb-cd' + urg + '"><b>' + esc(lab) + '</b>' + [[d, '天', 'd'], [h, '時', 'h'], [m, '分', 'm'], [x, '秒', 's']].map(function (a) { return '<span class="fb-box">' + dg(a[0], a[2]) + '<small>' + a[1] + '</small></span>'; }).join('') + '</div>';
  }
  function hasCd(o) { return o.cd && o.cd.on && (o.end || o.cd.mode === 'daily'); }
  // "sold" line and "selling fast" pill
  function fomo(o) {
    var f = o.fomo; if (!f) return '';
    var n = Math.max(0, Math.round(+f.base || 0)), out = '';
    if (f.on && n > 0) out += '<span>' + esc(String(f.label || '已售出 {n} 件').replace('{n}', n.toLocaleString('en-US'))) + '</span>';
    if (f.hot) out += '<span class="hot">' + esc(f.hotText || '🔥 熱銷中') + '</span>';
    return out ? '<div class="fb-fomo">' + out + '</div>' : '';
  }

  function row(p, note, qty, price, checked) {
    return '<div class="fb-row">' + (checked ? '<input type="checkbox" checked disabled aria-label="已包含">' : '<span></span>') + pic(p) +
      '<span class="fb-n">' + esc(p.title) + (note ? ' <em>' + esc(note) + '</em>' : '') + '</span>' +
      '<span class="fb-p">' + (qty > 1 ? qty + ' × ' : '') + nt(price) + '</span></div>';
  }
  function totals(full, pay) {
    var save = full - pay;
    return '<div class="fb-tot"><span>' + (save > 0 ? '原價 <s class="fb-strike">' + nt(full) + '</s>' : '') + '</span><span>' +
      (save > 0 && D.showSave ? '<span class="fb-sv">省 NT$<span class="fb-cnt" data-to="' + Math.round(save / 100) + '">' + Math.round(save / 100).toLocaleString('en-US') + '</span></span> ' : '') + '<b>' + nt(pay) + '</b></span></div>';
  }
  function card(o, inner, badge, btn) {
    return '<div class="fb-card fb-t-' + esc(o.type) + '" data-offer="' + esc(o.id) + '">' + (hasCd(o) ? cdHTML(o) : '') +
      '<div class="fb-hd"><span>' + esc(o.title) + '</span>' + (badge ? '<span class="fb-badge">' + esc(badge) + '</span>' : '') + '</div>' +
      (o._soon ? '<div class="fb-soon">預覽 Preview · ' + esc(o.start.slice(5).replace('-', '/')) + ' 開始，顧客尚看不到</div>' : '') + fomo(o) + inner +
      (btn !== false ? '<button type="button" class="fb-cta">' + esc(btn || D.btnText) + '</button>' : '') +
      '<div class="fb-msg" role="status"></div></div>';
  }
  function progress(have, need, done, todo) {
    var k = need > 0 ? Math.min(1, have / need) : 1;
    return '<div class="fb-bar"><i style="width:' + Math.round(k * 100) + '%"></i></div><p class="fb-note">' + (have >= need ? done : todo.replace('{x}', nt(need - have))) + '</p>';
  }

  // a choice list (radio for 1, checkboxes for more); each pick may have a variant menu
  function pickSteps(o) {
    return o._steps.map(function (S, i) {
      var radio = S.max === 1 && S.min === 1, name = 'fb-' + o.id + '-' + i;
      var pre = S.pre || [S.ps.filter(function (p) { return p.handle === P.handle; })[0] || (S.min > 0 ? S.ps[0] : null)];
      var rng = S.hideRange ? '' : S.free ? '' : S.min === S.max ? '選 ' + S.min + ' 件' : S.min ? '選 ' + S.min + '–' + S.max + ' 件' : '可選 · 最多 ' + S.max + ' 件';
      return '<div class="fb-step" data-i="' + i + '"><div class="fb-sh"><span>' + (S.free ? '🎁 ' : S.noNum ? '' : (i + 1) + '. ') + esc(S.st.title || '') + '</span><em>' + rng + '</em></div>' +
        S.ps.map(function (p) {
          var av = okVariants(o, p).filter(function (v) { return v.available; }), cv = p === P.full ? curVariant(o) : null, v = (cv && av.indexOf(cv) > -1 ? cv : av[0]) || p.variants[0], on = pre.indexOf(p) > -1 && av.length;
          var price = function (x) { return S.each ? S.each(x.price) : x.price; };
          var sel = av.length > 1 ? '<select class="fb-var" aria-label="規格">' + av.map(function (x) { return '<option value="' + x.id + '" data-price="' + x.price + '"' + (x === v ? ' selected' : '') + '>' + esc(x.title) + ' · ' + nt(x.price) + '</option>'; }).join('') + '</select>' : '';
          var shown = S.free ? '<s>' + nt(v.price) + '</s> 免費' : price(v) < v.price ? '<s>' + nt(v.price) + '</s> ' + nt(price(v)) : nt(v.price);
          return '<label class="fb-row fb-pick' + (on ? ' fb-on' : '') + (S.lock ? ' fb-lock' : '') + '"><input type="' + (radio ? 'radio' : 'checkbox') + '" name="' + name + '" value="' + v.id + '" data-h="' + esc(p.handle) + '" data-price="' + v.price + '"' + (on ? ' checked' : '') + (av.length && !S.lock ? '' : ' disabled') + '>' + pic(p) +
            '<span class="fb-n">' + esc(p.title) + (av.length ? '' : ' <em>售完</em>') + sel + '</span><span class="fb-p">' + shown + '</span></label>';
        }).join('') + '</div>';
    }).join('');
  }

  var builders = {
    bxgy: function (o) {
      return product(o.get).then(function (g) {
        var a = curVariant(o), b = firstAvail(g, o), q = o.getQty || 1, pct = +o.getPct || 0;
        var full = a.price + b.price * q, pay = a.price + Math.round(b.price * q * (100 - pct) / 100);
        o._items = [{ id: a.id, quantity: 1 }, { id: b.id, quantity: q }];
        var same = g.handle === P.handle;
        return card(o, row(P.full, '本商品', 1, a.price, true) + (same ? row(g, '第二件 ' + (pct >= 100 ? '免費' : zhe(pct)), q, b.price, true) : row(g, pct >= 100 ? '免費' : '享 ' + zhe(pct), q, b.price, true)) + totals(full, pay), (same ? '第二件 ' : '加購 ') + (pct >= 100 ? '免費' : zhe(pct)));
      });
    },
    bogo: function (o) {   // 10/30 (marketing): the main product's colour / switch is picked INSIDE the box (like Build your own), so the gift always comes with it
      var bq = o.buyQty || 1, gq = o.getQty || 1, n = bq + gq, gifts = (o.free || []).filter(Boolean);
      var hint = '<p class="fb-note fb-hint">🎁 請在此選擇規格與贈品，並按下方按鈕加入購物車，贈品才會一起送出</p>';
      var main = { st: { title: '' }, ps: [P.full], min: 1, max: 1, pre: [P.full], lock: true, noNum: true, hideRange: true };
      if (gifts.length) return many(gifts).then(function (ps) {
        main.qty = bq; main.st.title = '選擇規格（購買 ' + bq + ' 件）';
        o._steps = [main, { st: { title: ps.length > 1 ? '選擇贈品（' + gq + ' 件免費）' : '贈品（' + gq + ' 件免費）' }, ps: ps, min: 1, max: 1, free: true, qty: gq }];
        return card(o, pickSteps(o) + hint + '<div class="fb-tw"></div>', '買' + bq + '送' + gq);
      });
      main.qty = n; main.pq = bq; main.st.title = '選擇規格（買 ' + bq + ' 送 ' + gq + '）';   // pq = how many are paid for
      o._steps = [main];
      return Promise.resolve(card(o, pickSteps(o) + '<div class="fb-tw"></div>', '買' + bq + '送' + gq, '放入 ' + n + ' 件 · ' + D.btnText));
    },
    sale: function (o) {
      var v = curVariant(o), own = o.vars && o.vars[P.handle] && o.vars[P.handle].pct && +o.vars[P.handle].pct[v.id];
      var pct = own || +o.pct || 0, amt = own ? 0 : +o.amt || 0;
      var pay = amt ? Math.max(0, v.price - amt * 100) : Math.round(v.price * (100 - pct) / 100);
      var scope = (o.show.vendors || [])[0] ? o.show.vendors[0] + ' 全品牌商品' : '指定商品';
      return Promise.resolve(card(o, '<p class="fb-note">' + esc(scope) + ' · 結帳自動折扣' + (v.title && v.title !== 'Default Title' ? '（' + esc(v.title) + '）' : '') + '</p>' + totals(v.price, pay), amt ? '折 NT$' + amt.toLocaleString('en-US') : zhe(pct), false));
    },
    vsale: function (o) {
      // live: Shopify already has the sale price (and the old price as compare-at); draft: show the planned price
      var v = curVariant(), m = (o.prices || {})[P.handle] || {}, sp = m[v.id];
      if (sp == null && !LIVE) { var k = Object.keys(m)[0]; if (!k) return Promise.resolve(''); v = P.full.variants.filter(function (x) { return String(x.id) === k; })[0] || v; sp = m[k]; }
      var full = LIVE ? Math.max(v.price, v.compare_at_price || 0) : v.price, pay = LIVE ? v.price : Math.round(+sp * 100);
      if (sp == null || !(pay < full)) return Promise.resolve('');
      return Promise.resolve(card(o, '<p class="fb-note">品牌特價' + (v.title && v.title !== 'Default Title' ? '（' + esc(v.title) + '）' : '') + (o.end ? ' · 至 ' + esc(o.end.slice(5).replace('-', '/')) : '') + '</p>' + totals(full, pay), D.badge + ' ' + Math.round((full - pay) / full * 100) + '%', false));
    },
    volume: function (o) {
      var v = curVariant(o), ts = (o.tiers || []).filter(function (t) { return +t.q > 1; }).sort(function (a, b) { return a.q - b.q; });
      if (!ts.length) return Promise.resolve('');
      var name = 'fb-' + o.id + '-q', best = ts[ts.length - 1];
      var html = '<div class="fb-step">' + [{ q: 1, v: 0 }].concat(ts).map(function (t, i) {
        var unit = Math.round(v.price * (100 - (+t.v || 0)) / 100);
        return '<label class="fb-row fb-pick fb-vol' + (i === 1 ? ' fb-on' : '') + '"><input type="radio" name="' + name + '" value="' + t.q + '" data-unit="' + unit + '"' + (i === 1 ? ' checked' : '') + '>' +
          '<span class="fb-q">' + t.q + '</span><span class="fb-n">買 ' + t.q + ' 件' + (t.v ? ' <em>每件 ' + zhe(+t.v) + '</em>' : '') + '</span><span class="fb-p">' + (t.v ? '<s>' + nt(v.price * t.q) + '</s> ' : '') + nt(unit * t.q) + '</span></label>';
      }).join('') + '</div><div class="fb-tw"></div>';
      o._vol = { v: v };
      return Promise.resolve(card(o, html, '最高 ' + zhe(+best.v)));
    },
    fbt: function (o) { return addons(o, true); },
    addon: function (o) { return addons(o, false); },
    combo: function (o) {
      // the discount is on each of the chosen items (this one included) + a free gift
      return many(o.gifts).then(function (gs) {
        var v = curVariant(o), gq = o.giftQty || 1, d = o.disc || { kind: 'pct', v: 0 };
        var each = d.kind === 'amt' ? Math.max(0, v.price - (+d.v || 0) * 100) : d.kind === 'price' ? Math.min(v.price, (+d.v || 0) * 100) : Math.round(v.price * (100 - (+d.v || 0)) / 100);
        o._base = [{ id: v.id, quantity: 1, price: v.price, pay: each, code: true }];
        o._steps = gs.length ? [{ st: { title: gs.length > 1 ? '選擇贈品（' + gq + ' 件免費）' : '贈品（' + gq + ' 件免費）' }, ps: gs, min: 1, max: 1, free: true, qty: gq }] : [];
        var off = d.kind === 'amt' ? '折 NT$' + (+d.v).toLocaleString('en-US') : d.kind === 'price' ? '特價 ' + nt(each) : zhe(+d.v);
        return card(o, row(P.full, '本商品 · ' + off, 1, v.price, true) + pickSteps(o) + '<div class="fb-tw"></div>', off + (gs.length ? ' + 贈品' : ''));
      });
    },
    gift: function (o) {
      return Promise.all([product(o.gift), cart()]).then(function (r) {
        var g = r[0], c = r[1], v = firstAvail(g), need = Math.round((+o.min || 0) * 100), have = c.total_price || 0;
        var inCart = (c.items || []).some(function (it) { return String(it.variant_id) === String(v.id); });
        o._items = [{ id: v.id, quantity: 1 }];
        var ok = have >= need && !inCart;
        return card(o, row(g, '贈品', 1, v.price) + progress(have, need, inCart ? '贈品已在購物車，結帳時免費' : '已達門檻，可領取贈品', '購物車再買 {x} 即可免費獲得'),
          '滿 NT$' + (+o.min || 0).toLocaleString('en-US') + ' 送', ok ? '領取贈品 · 免費' : false);
      });
    },
    tier: function (o) {
      var ts = (o.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
      if (!ts.length) return Promise.resolve('');
      return Promise.all([cart(), many(ts.filter(function (t) { return t.kind === 'gift'; }).map(function (t) { return t.gift; }))]).then(function (r) {
        var c = r[0], gs = r[1], have = c.total_price || 0, byH = {};
        gs.forEach(function (g) { byH[g.handle] = g; });
        var reached = ts.filter(function (t) { return have >= t.min * 100; }), next = ts.filter(function (t) { return have < t.min * 100; })[0];
        var what = function (t) { return t.kind === 'gift' ? '送 ' + (byH[t.gift] ? byH[t.gift].title : '贈品') : t.kind === 'amt' ? '折 NT$' + (+t.v).toLocaleString('en-US') : '享 ' + zhe(+t.v); };
        var list = '<ul class="fb-tiers">' + ts.map(function (t) { var on = have >= t.min * 100; return '<li class="' + (on ? 'fb-on' : '') + '"><span>' + (on ? '✓ ' : '') + '滿 NT$' + (+t.min).toLocaleString('en-US') + '</span><b>' + esc(what(t)) + '</b></li>'; }).join('') + '</ul>';
        var top = next || ts[ts.length - 1];
        var gift = reached.filter(function (t) { return t.kind === 'gift' && byH[t.gift]; }).slice(-1)[0], gv = gift ? firstAvail(byH[gift.gift]) : null;
        var gin = gv && (c.items || []).some(function (it) { return String(it.variant_id) === String(gv.id); });
        o._items = gv && !gin ? [{ id: gv.id, quantity: 1 }] : null;
        return card(o, list + progress(have, top.min * 100, gin ? '已達最高優惠，贈品已在購物車' : '已達最高優惠，結帳自動折扣', '購物車再買 {x} 即可' + what(top)), '滿額優惠', o._items ? '領取贈品 · 免費' : false);
      });
    },
    fixed: function (o) {
      return many(o.items).then(function (ps) {
        if (!ps.length) return '';
        var vs = ps.map(function (p) { return p === P.full ? curVariant(o) : firstAvail(p, o); }), full = vs.reduce(function (s, v) { return s + v.price; }, 0), pay = Math.min(full, Math.round(+o.price * 100));
        o._items = vs.map(function (v) { return { id: v.id, quantity: 1, code: true }; });
        return card(o, ps.map(function (p, i) { return row(p, '', 1, vs[i].price, true); }).join('') + totals(full, pay), D.badge + ' ' + Math.round((full - pay) / full * 100) + '%');
      });
    },
    byo: function (o) {
      var steps = o.steps || [];
      return Promise.all(steps.map(function (st) { return many(st.items); })).then(function (all) {
        o._steps = all.map(function (ps, i) { var st = steps[i]; return { st: st, ps: ps, min: Math.max(0, +st.min || 0), max: Math.max(1, +st.max || 1) }; });
        return card(o, pickSteps(o) + '<div class="fb-tw"></div>', '自選組合');
      });
    }
  };
  // frequently bought together (all ticked) / add-ons (tick what you want), the main product is always in
  function addons(o, all) {
    return Promise.all([product(o.main || P.handle), many(o.items)]).then(function (r) {
      var m = r[0], ps = r[1], d = o.disc || { kind: 'pct', v: 0 }, n = (o.items || []).length || 1, setPrice = d.kind === 'price';
      if (!ps.length) return '';
      var mv = m === P.full ? curVariant(o) : firstAvail(m, o);
      o._base = [{ id: mv.id, quantity: 1, price: mv.price, code: true }];
      var each = d.kind === 'pct' ? function (c) { return Math.round(c * (100 - (+d.v || 0)) / 100); } : d.kind === 'amt' ? function (c) { return Math.max(0, c - Math.floor((+d.v || 0) / n) * 100); } : null;
      o._steps = [{ st: { title: all ? '一起買更划算' : '加購優惠' }, ps: ps, min: setPrice ? ps.length : 0, max: ps.length, pre: all || setPrice ? ps : [], lock: setPrice, each: each, noNum: true, hideRange: setPrice || all, code: true }];
      var badge = d.kind === 'pct' ? '加購 ' + zhe(+d.v) : d.kind === 'amt' ? '加購折 NT$' + (+d.v).toLocaleString('en-US') : '組合價 NT$' + (+d.v).toLocaleString('en-US');
      return card(o, row(m, '本商品', 1, mv.price, true) + pickSteps(o) + '<div class="fb-tw"></div>', badge);
    });
  }

  // what is chosen in a card with choices → cart lines and the price
  function state(o, el) {
    var items = [], full = 0, paid = 0, ok = true, add = 0;
    (o._base || []).forEach(function (b) { items.push({ id: b.id, quantity: b.quantity, code: b.code }); full += b.price * b.quantity; paid += (b.pay != null ? b.pay : b.price) * b.quantity; });
    (o._steps || []).forEach(function (S, i) {
      var picked = el.querySelectorAll('.fb-step[data-i="' + i + '"] input:checked');
      if (picked.length < S.min || picked.length > S.max) ok = false;
      picked.forEach(function (inp) {
        var q = S.qty || 1, pr = +inp.getAttribute('data-price') * q; full += pr;
        if (!S.free) { paid += S.each ? S.each(pr / q) * q : S.pq ? pr / q * S.pq : pr; add++; }
        items.push({ id: +inp.value, quantity: q, code: !S.free });
      });
    });
    var pay = paid, d = o.disc || {};
    if (o.type === 'byo') pay = o.priceType === 'pct' ? Math.round(full * (100 - (+o.pct || 0)) / 100) : o.priceType === 'off' ? Math.max(0, full - (+o.off || 0) * 100) : Math.min(full, (+o.price || 0) * 100);
    else if ((o.type === 'fbt' || o.type === 'addon') && d.kind === 'price') pay = Math.min(full, (+d.v || 0) * 100);
    if ((o.type === 'fbt' || o.type === 'addon') && !add) ok = false;
    return { ok: ok && items.length > 0, items: items, full: full, pay: pay };
  }
  function update(o, el, animate) {
    var tw = el.querySelector('.fb-tw'), btn = el.querySelector('.fb-cta'); if (!tw || !btn) return;
    if (o._vol) {
      var r0 = el.querySelector('input:checked'), q = +r0.value, unit = +r0.getAttribute('data-unit');
      el.querySelectorAll('.fb-pick').forEach(function (l) { l.classList.toggle('fb-on', l.querySelector('input').checked); });
      o._items = [{ id: o._vol.v.id, quantity: q }];
      tw.innerHTML = totals(o._vol.v.price * q, unit * q); btn.textContent = '放入 ' + q + ' 件 · ' + D.btnText;
    } else {
      var r = state(o, el);
      o._items = r.items; btn.disabled = !r.ok;
      el.querySelectorAll('.fb-pick').forEach(function (l) { l.classList.toggle('fb-on', l.querySelector('input').checked); });
      tw.innerHTML = r.ok ? totals(r.full, r.pay) : '<p class="fb-note">' + (o.type === 'fbt' || o.type === 'addon' ? '請勾選至少一件加購商品' : '請完成每一步的選擇') + '</p>';
    }
    if (animate) tw.querySelectorAll('.fb-cnt').forEach(countUp);
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || j.error || '無法完成，請再試一次'); return j; }); });
  }
  function go(o, el, btn) {
    if (!o._items || !o._items.length) return;
    var msg = el.querySelector('.fb-msg'); btn.disabled = true; msg.textContent = '加入中…';
    var items = o._items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: { _fiss_bundle: o.id } }; });
    post('/cart/add.js', { items: items }).then(function () {
      if (!(LIVE && isCode(o))) { msg.textContent = '已加入購物車'; window.location.href = '/cart'; return; }
      msg.textContent = '套用組合優惠中…';
      var lines = o._items.filter(function (i) { return i.code; }).map(function (i) { return { v: i.id, q: i.quantity }; });
      return post(API, { offer: o.id, lines: lines }).then(function (j) {
        if (!j.code) throw new Error('無法取得優惠碼');
        msg.textContent = '已套用優惠，省 NT$' + Math.round(j.save || 0).toLocaleString('en-US');
        window.location.href = '/discount/' + encodeURIComponent(j.code) + '?redirect=%2Fcart';
      }).catch(function (e) { msg.textContent = '商品已加入購物車，但優惠未套用：' + e.message; btn.disabled = false; });
    }).catch(function (e) { msg.textContent = e.message; btn.disabled = false; });
  }

  var timer = 0, io = null;
  function render() {
    cartP = null;
    Promise.all(offers.map(function (o) { o._items = null; o._base = null; o._steps = null; o._vol = null; return (builders[o.type] ? builders[o.type](o) : Promise.resolve('')).catch(function () { return ''; }); }))
      .then(function (html) {
        var body = html.join('');
        if (!body) { root.hidden = true; return; }
        root.innerHTML = (LIVE ? '' : '<div class="fb-test">測試模式 TEST · 尚未建立折扣，購物車以原價計算</div>') + body;
        root.hidden = false;
        offers.forEach(function (o) {
          var el = root.querySelector('.fb-card[data-offer="' + o.id + '"]'); if (!el || !(o._steps || o._vol)) return;
          update(o, el, false);
          el.addEventListener('change', function (e) {
            var t = e.target;
            if (t.classList.contains('fb-var')) {
              var inp = t.closest('.fb-pick').querySelector('input'), opt = t.options[t.selectedIndex], pr = +opt.getAttribute('data-price');
              inp.value = opt.value; inp.setAttribute('data-price', pr);
              var S = o._steps && o._steps[+t.closest('.fb-step').getAttribute('data-i')], fp = t.closest('.fb-pick').querySelector('.fb-p');
              fp.innerHTML = S && S.free ? '<s>' + nt(pr) + '</s> 免費' : S && S.each && S.each(pr) < pr ? '<s>' + nt(pr) + '</s> ' + nt(S.each(pr)) : nt(pr);
            }
            var stepEl = t.closest('.fb-step');
            if (t.type === 'checkbox' && stepEl && o._steps) {
              var S2 = o._steps[+stepEl.getAttribute('data-i')], on = stepEl.querySelectorAll('input:checked');
              if (on.length > S2.max) t.checked = false;
            }
            update(o, el, true);
          });
        });
        root.querySelectorAll('.fb-cta').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var el = btn.closest('.fb-card'), o = offers.filter(function (x) { return x.id === el.getAttribute('data-offer'); })[0];
            if (o) go(o, el, btn);
          });
        });
        if (!timer && offers.some(hasCd)) timer = setInterval(function () {
          root.querySelectorAll('.fb-card').forEach(function (el) {
            var o = offers.filter(function (x) { return x.id === el.getAttribute('data-offer'); })[0], c = el.querySelector('.fb-cd');
            if (!c || !o || !hasCd(o)) return;
            var tmp = document.createElement('div'); tmp.innerHTML = cdHTML(o); var n = tmp.firstChild;
            c.className = n.className;
            n.querySelectorAll('.fb-dg').forEach(function (nd) {
              var od = c.querySelector('.fb-dg[data-k="' + nd.getAttribute('data-k') + '"]');
              if (od && od.textContent !== nd.textContent) { od.textContent = nd.textContent; od.classList.remove('fb-flip'); void od.offsetWidth; od.classList.add('fb-flip'); }
            });
          });
        }, 1000);
        // reveal when the card scrolls into view
        if (!io && 'IntersectionObserver' in window) io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fb-in'); e.target.querySelectorAll('.fb-cnt').forEach(countUp); io.unobserve(e.target); } });
        }, { threshold: .35 });
        root.querySelectorAll('.fb-card').forEach(function (c) { if (io) io.observe(c); else { c.classList.add('fb-in'); c.querySelectorAll('.fb-cnt').forEach(countUp); } });
      });
  }
  render();
  // a different variant chosen in the product form → prices again
  var last = (curVariant() || {}).id, rq = 0;
  document.addEventListener('change', function (e) {
    if (root.contains(e.target)) return;
    if (!e.target.closest || !e.target.closest('form[action*="/cart/add"]')) return;
    clearTimeout(rq); rq = setTimeout(function () { var id = (curVariant() || {}).id; if (id !== last) { last = id; render(); } }, 150);
  });
})();
